import React, { Component } from 'react';
import ReactDatePicker from 'react-datepicker';
import './index.scss';

export default class DatePicker extends Component {
    render() {
        const { className, label, hide, ...pickerProps } = this.props;
        if (hide) return null;
        return (
            <div className={`w-100 ${this.props.className || ''}`}>
                {this.props.label && <label htmlFor={this.props.id}>{this.props.label}</label>}
                <ReactDatePicker {...pickerProps} />
            </div>
        );
    }
}
